function active_filter_count(){
  let filterSections = document.querySelectorAll('.filter-wrap .filter-index');
  let all_filter_count = 0;
  filterSections.forEach(section => {
    section.querySelectorAll('input[type="checkbox"]:checked:not(.filter-available)').forEach((index,list) => {
      all_filter_count++;
    });
  });
  if(document.querySelector('.range-wrap.active-price-filter')){
    all_filter_count++;
  }
  if(all_filter_count > 0){
    document.querySelector('.all-filter-count').textContent = '('+all_filter_count+')';
    document.querySelector('.coll-filter-btm .clear-filter').classList.add('active');
  }else{
    document.querySelector('.all-filter-count').textContent = '';
    document.querySelector('.coll-filter-btm .clear-filter').classList.remove('active');
  }
}
active_filter_count();
class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.debouncedOnSubmit = debounce((event) => {
      if(event.target.name == 'sort_by'){
        document.querySelector('.sort-button span').textContent = event.target.getAttribute('data-val');
        document.querySelector('.sort-button span').setAttribute('data-val',event.target.value);
        document.querySelector('body').classList.remove('open-sort');
      }
      this.onSubmitHandler(event);
      // document.querySelector('body').classList.remove('open-filter','open-sort');
      typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
    }, 500);
    this.querySelector('form').addEventListener('input', this.debouncedOnSubmit.bind(this));
    // const applyfilter = this.querySelector('.apply-filter');
    // if (applyfilter) applyfilter.addEventListener('click', this.debouncedOnSubmit.bind(this));    
    const filterbtn = this.querySelectorAll('.filter-button');
    if(filterbtn) filterbtn.forEach((filter) => {
      filter.addEventListener('click',function(e){
        e.preventDefault();
        document.querySelector('body').classList.toggle('open-filter');
        document.querySelector('body').classList.remove('open-model','open-sort','open-drawer','open-menu','open-search');
        const filterBox = document.querySelector('.filter-box.filterwrap');
        if (filterBox) {
          filterBox.scrollTop = 0;
        }
      });
    });
    const sortbtn = this.querySelector('.sort-button');
    if (sortbtn) sortbtn.addEventListener('click',function(e){
      document.querySelector('body').classList.toggle('open-sort');
      document.querySelector('body').classList.remove('open-model','open-filter','open-drawer','open-menu','open-search');
    });
    if(document.querySelector('.sort-box')){
      this.querySelector('.sort-box').addEventListener('input', this.debouncedOnSubmit.bind(this));
    }
    const showbtn = this.querySelector('.show-button');
    if (showbtn) showbtn.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.remove('open-filter');
    });
  }
  static setListeners() {
      const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }
  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;
      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
      FacetFiltersForm.renderSectionFromFetch(url, event);
    });
    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }
  static renderSectionFromFetch(url, event) {
      fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        //FacetFiltersForm.renderActiveFilter(html);
        typeof infinitescroll == 'object' && typeof infinitescroll?.scolljs == 'function' && infinitescroll?.scolljs()
        if(typeof quickAddButton == 'function'){
          quickAddButton();
          if(document.querySelectorAll('.product-item.init-loading-item')) document.querySelectorAll('.product-item.init-loading-item').forEach((product) => {
            product.classList.remove('init-loading-item');
          });
        }
        filter_acco();
        load_more();
        setTimeout(() => {
          callBack(); 
        }, 200);
      });
    }
    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      //FacetFiltersForm.renderActiveFilter(html);
      if(typeof quickAddButton == 'function'){
        quickAddButton();
        if(document.querySelectorAll('.product-item.init-loading-item')) document.querySelectorAll('.product-item.init-loading-item').forEach((product) => {
          product.classList.remove('init-loading-item');
        });
      }
      filter_acco();
      load_more()
    }
    static renderProductGridContainer(html) {
      document.getElementById('collection-grid').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('collection-grid').innerHTML;
      document.querySelector('.active-filter-wrap').innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.active-filter-wrap').innerHTML;
      let count = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid').getAttribute('data-count');
      document.querySelector('.filter-total-count').textContent = count;
    }
    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const facetDetailsElements = parsedHTML.querySelectorAll('.facet-list');
      active_filter_count();
      const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.facet-list') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    }
    const facetsToRender = Array.from(facetDetailsElements).filter(element => !matchesIndex(element));
    facetsToRender.forEach((element) => {
      document.querySelector(`.filter-index[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });
  }
  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }
  static getSections() {
    return [
      {
        section: document.getElementById('collection-grid').dataset.id,
      }
    ]
  }
  // onSubmitHandler(event) {    
  //   event.preventDefault();
  //   const formData = new FormData(event.target.closest('form'));
  //   const searchParams = new URLSearchParams(formData).toString();
  //   FacetFiltersForm.renderPage(searchParams, event);    
  // }
  onSubmitHandler(event){
    event.preventDefault();
    const form = event.target.closest('form');
    let formData = new FormData(form);
    let searchParams = new URLSearchParams(formData).toString();
    const hasSizeFilter = searchParams.includes("filter.v.option.size");
    if (hasSizeFilter) {
      if (!searchParams.includes("filter.v.availability=1")) {
        searchParams += "&filter.v.availability=1";
      }
    } else {
      searchParams = searchParams
        .replace(/&?filter\.v\.availability=1/g, "")
        .replace(/\?&/, "?");
    }
    FacetFiltersForm.renderPage(searchParams, event);
    if (!document.querySelector('body').classList.contains('open-filter')) {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
    }
  }

}
FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();
document.addEventListener("DOMContentLoaded", (event) => {
  // document.querySelector('.active-filter-wrap').innerHTML = document.getElementById('collection-grid').querySelector('.active-filter').innerHTML;
  document.querySelector('.active-filter-wrap').innerHTML = document.querySelector('.active-filter-wrap').innerHTML;
});
function filterprice(){
  var inputLeft = document.querySelector(".price-left");
  var inputRight = document.querySelector(".price-right");
  var amountLeft = document.querySelector(".amount-left .amount-percentage");
  var amountRight = document.querySelector(".amount-right .amount-percentage");
  var thumbLeft = document.querySelector(".price-slider > .thumb.left");
  var thumbRight = document.querySelector(".price-slider > .thumb.right");
  var range = document.querySelector(".price-slider > .range");
  function setLeftValue() {
    var _this = inputLeft,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.min(parseInt(_this.value), parseInt(inputRight.value) - 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbLeft.style.left = percent + "%";
    amountLeft.innerHTML = _this.value;
    range.style.left = percent + "%";
  }
  setLeftValue();
  function setRightValue() {
    var _this = inputRight,
        min = parseInt(_this.min),
        max = parseInt(_this.max);
    _this.value = Math.max(parseInt(_this.value), parseInt(inputLeft.value) + 1);
    var percent = ((_this.value - min) / (max - min)) * 100;
    thumbRight.style.right = (100 - percent) + "%";
    amountRight.innerHTML = _this.value;
    range.style.right = (100 - percent) + "%";
    _this.style.zIndex  = 3;    
  }
  setRightValue();
  inputLeft.addEventListener("input", setLeftValue);
  inputRight.addEventListener("input", setRightValue);
}
if(document.querySelector('.range-wrap')){
  filterprice();
}
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
function fnBrowserDetect(){
  let userAgent = navigator.userAgent;
  let browserName;
  if(userAgent.match(/chrome|chromium|crios/i)){
    browserName = "chrome";
  }else if(userAgent.match(/firefox|fxios/i)){
    browserName = "firefox";
  }  else if(userAgent.match(/safari/i)){
    browserName = "safari";
  }else if(userAgent.match(/opr\//i)){
    browserName = "opera";
  } else if(userAgent.match(/edg/i)){
    browserName = "edge";
  }else{
    browserName="no-browser";
  }
  document.getElementById('MainContent').classList.add(browserName);
}
fnBrowserDetect();
function filter_acco(){
  if(document.querySelectorAll('.filter-title')) document.querySelectorAll('.filter-title').forEach((filterAcco) => {
    filterAcco.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let allFacetLists = document.querySelectorAll('.facet-list');
      let currentFacetList = filterAcco.closest('.facet-list');
      allFacetLists.forEach((facetList) => {
        if(facetList !== currentFacetList){
          facetList.classList.remove("active");
          let content = facetList.querySelector(".filter-inr-wrap");
          if(content) content.style.height = '0px';
        }
      });
      if(currentFacetList.classList.contains("active")){
        currentFacetList.classList.remove("active");
        let content = currentFacetList.querySelector(".filter-inr-wrap");
        if(content) content.style.height = '0px';
      }else{
        currentFacetList.classList.add("active");
        let content = currentFacetList.querySelector(".filter-inr-wrap");
        if(content){
          if(content.querySelector("ul")){
            content.style.height = content.querySelector("ul").scrollHeight + "px";
          }else if(content.querySelector(".range-wrap")){
            content.style.height = content.querySelector(".range-wrap").scrollHeight + "px";
          }
        }
      }
    });
  });
  if(document.querySelectorAll('.snippet-product-grid')) document.querySelectorAll('.snippet-product-grid').forEach((grid) => {
    grid.addEventListener('mouseover', function () {
      let gridMeta = grid.querySelector('.grid-meta');
      if (!gridMeta) return;
      let top = gridMeta.querySelector('.grid-meta-top');
      let btm = gridMeta.querySelector('.grid-meta-btm');
      if (!top || !btm) return;
      let topHeight = top.offsetHeight;
      let btmHeight = btm.offsetHeight;
      let maxHeight = Math.max(topHeight, btmHeight);
      gridMeta.style.height = maxHeight + 'px';
    });
  });
}
filter_acco();